import DynamoItem from './dynamoItem';

export default class DynamoItems {

    public items: { [id: string]: DynamoItem; };
}

